<!-- SIDE PANEL -->
@if (!cdkConfig.layout.sidepanel.hidden && cdkConfig.layout.sidepanel.position === 'left') {
  <!-- PANEL CONTENT -->
}
<!-- / SIDE PANEL -->

<div id="main">

  <!-- NOTIFICACOES -->
  <ng-container>
    <notification></notification>
  </ng-container>

  <!-- TOOLBAR: Above -->
  @if (cdkConfig.layout.toolbar.position === 'above') {
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  }
  <!-- / TOOLBAR: Above -->

  <div id="container-1" class="container">

    <!-- NAVBAR: Left -->
    @if (cdkConfig.layout.navbar.position === 'left') {
      <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
    }
    <!-- / NAVBAR: Left -->

    <div id="container-2" class="container">

      <!-- TOOLBAR: Below fixed -->
      @if (cdkConfig.layout.toolbar.position === 'below-fixed') {
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      }
      <!-- / TOOLBAR: Below fixed -->

      <div id="container-3" class="container" cdkScrollbar
        [cdkScrollbarOptions]="{suppressScrollX: false, suppressScrollY: true}">

        <!-- TOOLBAR: Below static -->
        @if (cdkConfig.layout.toolbar.position === 'below-static') {
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        }
        <!-- / TOOLBAR: Below static -->

        <!-- CONTENT -->
        <content></content>
        <!-- / CONTENT -->

        <!-- FOOTER: Below static -->
        @if (cdkConfig.layout.footer.position === 'below-static') {
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        }
        <!-- / FOOTER: Below static -->

      </div>

      <!-- FOOTER: Below fixed -->
      @if (cdkConfig.layout.footer.position === 'below-fixed') {
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      }
      <!-- / FOOTER: Below fixed -->

    </div>

    <!-- NAVBAR: Right -->
    @if (cdkConfig.layout.navbar.position === 'right') {
      <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
    }
    <!-- / NAVBAR: Right -->

  </div>

  <!-- FOOTER: Above -->
  @if (cdkConfig.layout.footer.position === 'above') {
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  }
  <!-- FOOTER: Above -->

</div>

<!-- SIDE PANEL -->
@if (!cdkConfig.layout.sidepanel.hidden && cdkConfig.layout.sidepanel.position === 'right') {
  <!-- PANEL CONTENT -->
}
<!-- / SIDE PANEL -->

<!-- AJUDA PANEL -->
<cdk-sidebar name="ajudaPanel" position="right"
  [ngClass]="{'ajuda-panel': !mobileMode, 'ajuda-panel-mobile': mobileMode}"
  [class.hidden]="cdkConfig.layout.toolbar.hidden">
  <section role="region" aria-label="Painel de Ajuda">
    <ajuda-panel></ajuda-panel>
  </section>
</cdk-sidebar>
<!-- / AJUDA PANEL -->

<!-- CHAT PANEL -->
<cdk-sidebar name="chatPanel" position="right" class="chat-panel" tabindex="-1"
  [ngClass]="{'chat-open': chatOpen === true}"
  [folded]="false"
  [foldedAutoTriggerOnHover]="false"
  [class.hidden]="cdkConfig.layout.toolbar.hidden"
  *showIfRole="'ROLE_COLABORADOR'">
  <chat-panel tabindex="-1"
    (toogleChatHandler)="toogleChat($event)">
  </chat-panel>
</cdk-sidebar>
<!-- / CHAT PANEL -->

<!-- QUICK PANEL -->
<cdk-sidebar name="quickPanel" position="right" class="quick-panel"
  [folded]="true"
  lockedOpen="gt-md"
  [foldedWidth]="56"
  [foldedAutoTriggerOnHover]="false"
  [class.hidden]="cdkConfig.layout.toolbar.hidden"
  role="region" aria-label="Últimas Operações">
    <quick-panel></quick-panel>
</cdk-sidebar>
<!-- / QUICK PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS                                                                                            -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  @if (!cdkConfig.layout.toolbar.hidden) {
    <section role="region" aria-label="Barra de ferramentas">
      <toolbar
        [ngClass]="cdkConfig.layout.toolbar.customBackgroundColor === true ? cdkConfig.layout.toolbar.position + ' ' + cdkConfig.layout.toolbar.background : cdkConfig.layout.toolbar.position">
      </toolbar>
    </section>
  }
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
  @if (!cdkConfig.layout.footer.hidden) {
    <footer
      [ngClass]="cdkConfig.layout.footer.customBackgroundColor === true ? cdkConfig.layout.footer.position + ' ' + cdkConfig.layout.footer.background : cdkConfig.layout.footer.position">
    </footer>
  }
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
  @if (!cdkConfig.layout.navbar.hidden) {
    <cdk-sidebar name="navbar" class="navbar-cdk-sidebar"
      [folded]="cdkConfig.layout.navbar.folded"
      lockedOpen="gt-md"
      >
      <navbar [variant]="cdkConfig.layout.navbar.variant" class="left-navbar" id="main-navigation" tabindex="-1"></navbar>
    </cdk-sidebar>
  }
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
  @if (!cdkConfig.layout.navbar.hidden) {
    <cdk-sidebar name="navbar" position="right" class="navbar-cdk-sidebar"
      [folded]="cdkConfig.layout.navbar.folded"
      lockedOpen="gt-md"
      >
      <navbar [variant]="cdkConfig.layout.navbar.variant" class="right-navbar" id="main-navigation" tabindex="-1"></navbar>
    </cdk-sidebar>
  }
</ng-template>
<!-- / RIGHT NAVBAR -->
